<sz-pill variant="outline">{{ type() }}</sz-pill>
